import { render, staticRenderFns } from "./unionOrderRecord.vue?vue&type=template&id=cf0ed240&scoped=true&"
import script from "./unionOrderRecord.vue?vue&type=script&lang=js&"
export * from "./unionOrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./unionOrderRecord.vue?vue&type=style&index=0&id=cf0ed240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0ed240",
  null
  
)

export default component.exports